export const USER_REPORT_ACTION_START = 'USER_REPORT_ACTION_START';
export const USER_REPORT_ACTION_ERROR = 'USER_REPORT_ACTION_ERROR';
export const GET_ALL_USER_REPORTS = 'GET_ALL_USER_REPORTS';
export const GET_USER_REPORT = 'GET_USER_REPORT';

export const userReportActionStart = () => ({ type: USER_REPORT_ACTION_START });
export const userReportActionError = (error: any) => ({ type: USER_REPORT_ACTION_ERROR, payload: error });
export const getAllUserReportsAction = (reports: any[]) => ({ type: GET_ALL_USER_REPORTS, payload: reports });
export const getUserReportAction = (report: any) => ({ type: GET_USER_REPORT, payload: report }); 